{
  "action": {
    "allow": "Allow",
    "block": "Block",
    "deny": "Deny",
    "drop": "Drop"
  },
  "add": "Add",
  "address": {
    "city": "City",
    "country": "Country",
    "line1": "Address line 1",
    "line2": "Address line 2",
    "state": "State",
    "zip": "Zip code"
  },
  "back": "Back",
  "blocked": "Blocked",
  "cancel": "Cancel",
  "close": "Close",
  "collapse": "Collapse",
  "components": {
    "alarm_level_chart": {
      "go_to_performance": "Go to site performance page",
      "header": "Alarm Levels"
    },
    "blocking_drawer": {
      "cancel": "Cancel",
      "confirm": "Close without saving",
      "content": "You are attempting to close the drawer with unsaved changes."
    },
    "date_range_selector": {
      "apply": "Apply",
      "clear": "Clear",
      "end": "To",
      "errors": {
        "invalid_duration": "Time range cannot exceed {{duration}}",
        "invalid_range": "To time must be later than From time"
      },
      "intervals": {
        "BWC": "BWC Usage Period",
        "LAST_12_HOURS": "Last 12 Hours",
        "LAST_15_MINUTES": "Last 15 Minutes",
        "LAST_1_HOUR": "Last 1 Hour",
        "LAST_24_HOURS": "Last 24 Hours",
        "LAST_30_DAYS": "Last 30 Days",
        "LAST_30_MINUTES": "Last 30 Minutes",
        "LAST_3_HOURS": "Last 3 Hours",
        "LAST_7_DAYS": "Last 7 Days",
        "LAST_90_DAYS": "Last 90 Days",
        "LAST_MONTH": "Last Month",
        "custom": "Custom"
      },
      "start": "From",
      "title": "Select time range"
    },
    "device_drawer": {
      "error": {
        "api": "There was an error loading device details."
      },
      "tab": {
        "cellular": {
          "error": {
            "api": "There was an error loading device cellular status."
          },
          "inactive": {
            "text": "Cellular status is unavailable.",
            "title": "Device inactive"
          },
          "property": {
            "active_sim_slot": {
              "name": "Active SIM Slot"
            },
            "assigned_ip": {
              "description": "5G/LTE wireless IP",
              "name": "Assigned IP (DHCP)"
            },
            "connection_status": {
              "name": "Radio Connection Status"
            },
            "network_carrier": {
              "name": "Network Carrier"
            },
            "network_type": {
              "name": "Network Type"
            },
            "signal": {
              "description": "The strength and clarity of network signals affect connection reliability and performance.",
              "name": "Signal Quality"
            }
          },
          "title": "Cellular",
          "unavailable": {
            "link": "Contact Bigleaf",
            "text": "This site can have an integrated 5G/LTE circuit. Contact Bigleaf to get started with <strong>Bigleaf Wireless Connect</strong>."
          }
        },
        "overview": {
          "property": {
            "device_status": {
              "name": "Device status"
            },
            "device_type": {
              "name": "Device type"
            },
            "firmware_version": {
              "name": "Firmware version"
            },
            "iccid": {
              "description": "Of active slot",
              "name": "ICCID"
            },
            "imei": {
              "name": "IMEI"
            },
            "serial_number": {
              "name": "Serial number"
            },
            "site_config_version": {
              "name": "Site config version"
            },
            "uptime": {
              "error": {
                "api": "There was an error loading device uptime."
              },
              "name": "Online since"
            }
          },
          "title": "Overview"
        },
        "settings": {
          "form": {
            "active_sim_slot": {
              "name": "Switch SIM Slot"
            },
            "assigned_apn": {
              "name": "APN"
            },
            "sim_apn_mode": {
              "item": {
                "auto": "Auto",
                "manual": "Manual"
              },
              "name": "APN"
            },
            "sim_apn_value": {
              "name": "APN"
            }
          },
          "title": "Settings"
        }
      },
      "title": "Device Status"
    },
    "firmware_status_badge": {
      "aria_labels": {
        "New version available": "New firmware version",
        "Out of date": "Out of date.",
        "Unknown": "Unknown.",
        "Up to date": "Up to date"
      },
      "firmware_updating": "Software update is in progress since {{date}}.",
      "tooltips": {
        "New version available": {
          "description": "Upgrade now or wait until the next maintenance window, which will automatically update online devices.",
          "title": "New firmware version is available."
        },
        "Out of date": {
          "description": "Upgrade now to prevent potential issues.",
          "title": "Firmware is out of date."
        },
        "Unknown": {
          "description": "This device’s firmware upgrade status is currently unknown. Please reach out to support if you are having issues with your device.",
          "title": "Firmware status is unknown."
        },
        "Up to date": {
          "title": "Firmware is up to date"
        }
      }
    },
    "notes_drawer": {
      "EnvOp": {
        "description": "Restricted to Bigleaf Environment Operator users",
        "title": "Bigleaf Internal Notes"
      },
      "MSP": {
        "description": "Visible to Reseller and Provider users",
        "title": "Service Provider/MSP Notes"
      },
      "company": {
        "description": "You can find maintenance notes for this company here. Notes can include troubleshooting information, maintenance schedules, and links to tickets",
        "title": "Company notes"
      },
      "note": {
        "cancel": "Cancel",
        "clear": "Clear",
        "edit": "Edit note",
        "modified_by": "Modified by {{user}} on {{date}}",
        "placeholder": "Type your note here",
        "save": "Save note",
        "success": "Note has been saved"
      },
      "site": {
        "description": "You can find maintenance notes for this site here. Notes can include troubleshooting information, maintenance schedules, and links to tickets",
        "title": "Site notes"
      },
      "tooltip_one": "Notes for this {{context}} ({{count}} note)",
      "tooltip_other": "Notes for this {{context}} ({{count}} notes)",
      "tooltip_zero": "Notes for this {{context}} (no notes)"
    },
    "pass_input": {
      "hide_aria_label": "Hide password",
      "required": "This field is required",
      "show_aria_label": "Show password"
    },
    "phloem_status_badge": {
      "error": {
        "command": "Failed executing {{command}} at {{timestamp}}. Error details: {{details}}. Contact Bigleaf Support for assistance.",
        "register": "Failed to register device on {{timestamp}}. Error details: {{details}}. Contact Bigleaf Support for assistance."
      },
      "offline": {
        "label": "Offline",
        "tooltip": "Device is not connected to the server.",
        "tooltip_timestamp": "Device is not connected to the server. Last seen at {{timestamp}}."
      },
      "online": {
        "label": "Online",
        "tooltip": "Device is connected to the server.",
        "tooltip_timestamp": "Device is connected to the server. Last seen at {{timestamp}}."
      }
    },
    "promo_banner": {
      "collapse": "Collapse",
      "expand": "Expand",
      "next": "Next",
      "previous": "Previous",
      "slide_counter": "{{current}} / {{total}}",
      "whats_new": {
        "label": "What's new",
        "slides": {
          "0": {
            "description": "Bigleaf Edge Firewall is now generally available as a Cloud Connect add‑on, delivering integrated branch security with centralized management through the Bigleaf platform. Core capabilities include stateful traffic inspection, IPsec site‑to‑site VPN, VLAN segmentation, customizable traffic policies and firewall rules, port forwarding and NAT options, centralized logging, MAC filtering, and LAN client management. <br><br>To enable Edge Firewall, contact your company’s admin or your Bigleaf Sales Representative.",
            "title": "Edge Firewall and VPN is now available"
          },
          "1": {
            "description": "The Site Overview page brings together site condition, traffic activity, performance metrics, optimization activity, and uptime visibility into a single view, helping you quickly assess network health and accelerate troubleshooting.<br><br>New Optimization and Uptime insights also provide valuable proof points for your client conversations and business reviews, showing how you, along with Bigleaf, help optimize connectivity, maintain session continuity, and keep their users productive.<br><br>Read this <a>blog post</a> to learn more.",
            "title": "New Optimization and Uptime Insights"
          },
          "2": {
            "description": "You can now set custom data limits for each billing period to control circuit costs. When a circuit reaches its data threshold, you'll receive an alert and can choose to automatically stop all traffic - preventing billing surprises.<br>This feature is available on circuits running the latest firmware so make sure your firmware is up to date. You can find these settings in the circuit configuration under the advanced section. For more information, see <a>our help center article</a>.",
            "title": "Data metering feature on circuits"
          }
        }
      }
    },
    "reboot_device": {
      "blocker": {
        "cancel": "Cancel",
        "content": "The reboot process must complete before you leave this page.",
        "leave_page": "Leave page"
      },
      "button": {
        "reboot_device": "Reboot device"
      },
      "dialog": {
        "downtime_message": "Your device will be unreachable for a short period.",
        "footer": {
          "close": "Close",
          "reboot": "Reboot device",
          "retry_reboot": "Try rebooting again"
        },
        "headerText": {
          "failed": "Failed rebooting {{device_type}}",
          "finished": "Finished rebooting {{device_type}}",
          "pending": "Are you sure you want to reboot {{device_type}}?",
          "rebooting": "Rebooting {{device_type}}..."
        },
        "reboot_error": {
          "internet_down": "Your internet connection appears to be down. Contact Bigleaf support at 1-888-244-3133.",
          "internet_up": "For additional assistance, contact <a>Bigleaf Support</a> or use the Help button below",
          "unknown": "An error occurred while rebooting the device."
        },
        "reboot_success": "Device has been successfully rebooted and is fully operational.",
        "unfinished_reboot": {
          "cancel": "Cancel",
          "content": "The reboot process must complete before you leave this page.",
          "leave_page": "Leave page"
        }
      }
    },
    "session_expired_dialog": {
      "headerText": "Session expired"
    },
    "signal_grade_badge": {
      "grade": {
        "0": "Excellent",
        "1": "Good",
        "2": "Fair",
        "3": "Poor"
      }
    },
    "signal_quality_metrics": {
      "metric": {
        "rsrp": "RSRP",
        "rsrq": "RSRQ",
        "rssi": "RSSI",
        "snr": "SINR"
      }
    },
    "sites_table": {
      "drawer": {
        "issues": {
          "title": "Active Alerts"
        }
      }
    },
    "table_column_visibility_button": {
      "apply": "Apply",
      "columns": "Columns",
      "reset": "Reset to default"
    },
    "unsaved_changes_dialog": {
      "content": "You are attempting to leave the page with unsaved changes."
    },
    "upgrade_firmware": {
      "button": "Upgrade now",
      "disabled_tooltip": "Upgrades have been disabled for this company. Contact support to re-enable upgrades."
    },
    "upgrade_now_wizard": {
      "downtime_message": "While upgrading you can encounter a few minutes (typically 2-10) of site downtime.",
      "errors": {
        "upgrading": "This device is already scheduled for an upgrade and cannot be updated again at this time."
      },
      "footer": {
        "close": "Close",
        "retry_upgrade": "Try upgrading again",
        "upgrade_now": "Upgrade now"
      },
      "header": "Firmware upgrade",
      "labels": {
        "company": "Company:",
        "current_firmware": "Current firmware:",
        "firmware": "Firmware:",
        "firmware_version": "Firmware version:",
        "release_date": "Release date:",
        "site": "Site:",
        "target_firmware": "Target firmware:"
      },
      "release_notes": "See release notes",
      "unfinished_upgrade_dialog": {
        "cancel": "Cancel",
        "content": "The upgrade process must complete before you leave this page.",
        "leave_page": "Leave page"
      },
      "upgrade_badge": {
        "downloading": "Downloading...",
        "error": "Error upgrading",
        "installing": "Upgrading...",
        "queued": "Queued",
        "rebooting": "Rebooting...",
        "starting": "Starting...",
        "success": "Completed"
      },
      "upgrade_details": "Upgrade details",
      "upgrade_error": {
        "conflicting_upgrade": "A firmware upgrade is already in progress for {{cpe_serial}}. Please wait for that upgrade to complete before starting a new one.",
        "internet_down": "Your internet connection appears to be down. Contact Bigleaf support at 1-888-244-3133.",
        "internet_up": "For additional assistance, contact <a>Bigleaf Support</a> or use the Help button below",
        "unknown": "An unexpected error occurred while attempting to upgrade your CPE."
      },
      "upgrade_success": "Device has been upgraded successfully and site is online."
    },
    "vlan_badge": {
      "fields": {
        "address": "Address",
        "description": "Description",
        "name": "Name",
        "subnet": "Subnet"
      },
      "label": "VLAN {{id}}",
      "name": "VLAN name",
      "subnet": "Subnet"
    }
  },
  "continue": "Continue",
  "copied": "Copied",
  "copy": "Copy",
  "delete": "Delete",
  "disabled": "Disabled",
  "discard_changes": "Discard changes",
  "download": "Download",
  "download_csv": "Download CSV",
  "edit": "Edit",
  "enabled": "Enabled",
  "errors": {
    "access_error": "Your session has expired. Log in to the Web Dashboard again to continue.",
    "expired_session": "Your session has expired.",
    "invalid_address": {
      "description": "Unable to validate address. Would you like to save without validating or use the suggested address below?",
      "provided_address": {
        "apply": "Use entered address",
        "cancel": "Cancel",
        "description": "Unable to validate address. Would you like to use the address you entered below anyway?"
      },
      "skip_validation": "Save Without Validating",
      "suggested_address": "Use Suggested Address"
    },
    "invalid_request_error": "There was an error processing your request. This error has been logged and our support team will investigate.",
    "network_error": "We can't complete your request. Check your internet connection and try again. If the problem continues, contact Bigleaf Support.",
    "permissions_error": "Your user role doesn't allow you to perform this action. If you need assistance, contact your system administrator.",
    "unknown_error": "There was an unknown error. Try again"
  },
  "exit-without-saving": "Exit Without Saving",
  "expand": "Expand",
  "fields": {
    "email": {
      "invalid": "Invalid email address",
      "max_length": "Email must be at most 254 characters",
      "required": "Email is required"
    },
    "username": {
      "invalid": "Username can only contain alphanumeric characters, '@', '^', '$', ''', '.', '!', '_', '`', '-', '+', '#', and '~'",
      "max_length": "Username must be at most 32 characters",
      "required": "Username is required"
    }
  },
  "filters": {
    "add_filters": "Add filter",
    "add_filters_description": "You’re adding filters to {{path}}",
    "add_new_filter": "Add new filter",
    "all_filters": "All filters",
    "apply": "Apply",
    "clear": "Clear",
    "clear_all_filters": "Clear all filters",
    "count": "{{label}}: {{count}}",
    "count_zero": "{{label}}",
    "filter_key": "Filter key",
    "filter_value": "Filter value",
    "no_results": "No results found",
    "tabs": {
      "active": {
        "active_filters": "Active Filters",
        "apply": "Apply filters",
        "clear": "Clear active",
        "no_active_filters": "No active filters",
        "no_active_filters_description": "Currently you have no active filters. Add a new filter to see it in this section.",
        "recent_filters": "Recent Filters",
        "title": "Active"
      },
      "favorites": {
        "apply": "Apply favorites",
        "clear": "Clear favorites",
        "favorite_filters": "Favorite Filters",
        "no_favorites": "Make filters favorite",
        "no_favorites_description": "Click on a star to make a filter your favorite. You can set up to 3 filters as favorites. Favorite filters will appear next to the filters button on the page.",
        "title": "Favorites"
      }
    },
    "title": "Filters"
  },
  "loading": "Loading",
  "logout": "Logout",
  "no": "No",
  "no_data": "No data available",
  "not_applicable": "N/A",
  "numAsDay": "{{value}} day",
  "numAsDays": "{{value}} days",
  "numAsHour": "{{value}} hour",
  "numAsHours": "{{value}} hours",
  "numAsMilliseconds": "{{value}} ms",
  "numAsMinute": "{{value}} min",
  "numAsMinutes": "{{value}} mins",
  "numAsMonth": "{{value}} month",
  "numAsMonths": "{{value}} months",
  "numAsSecond": "{{value}} sec",
  "numAsSeconds": "{{value}} secs",
  "numAsWeek": "{{value}} week",
  "numAsWeeks": "{{value}} weeks",
  "numAsYear": "{{value}} year",
  "numAsYears": "{{value}} years",
  "open": "Open",
  "print": "Print",
  "remove": "Remove",
  "save": "Save",
  "save_changes": "Save changes",
  "search": "Search",
  "shortNumAsDays": "{{value}}d",
  "shortNumAsHours": "{{value}}h",
  "shortNumAsMinutes": "{{value}}m",
  "shortNumAsMonths": "{{value}}mo",
  "shortNumAsSeconds": "{{value}}s",
  "shortNumAsWeeks": "{{value}}w",
  "shortNumAsYears": "{{value}}y",
  "site": "Site",
  "timeAgo": "{{time}} ago",
  "unsaved_changes": "You have unsaved changes. Save them.",
  "user_role": {
    "Company Admin": "Company Admin",
    "Disabled": "Disabled",
    "Super Admin": "Super Admin",
    "Unknown": "Unknown",
    "User": "User"
  },
  "view": "View",
  "welcome": "Welcome, {{name}}!",
  "yes": "Yes"
}
